import type { RouteLocationNormalizedLoaded, RouteParams } from 'vue-router';


type RouteLike = Pick<RouteLocationNormalizedLoaded, 'name'> & {
  params?: RouteParams;
};

/**
 * Strip i18n suffix (`___en`) and substitute route params into the page name
 * (same algorithm as ACL middleware).
 */
export default function normalizePageName(to: RouteLike): string | null {
  if (!to.name) {
    return null;
  }

  let pageName = to.name.toString().replace(/___..$/, '');

  if (to.params) {
    Object.entries(to.params).forEach(([key, value]) => {
      pageName = pageName.replace(
        key,
        Array.isArray(value) ? value.join('/') : String(value ?? ''),
      );
    });
  }

  return pageName;
}
